import React from 'react';
import PropTypes from 'prop-types';
import RpKeywordsFilter from 'components/commons/RpKeywordsFilter';
import useFilterStore from 'zustandStore/useFilterStore';

const KeywordsFilter = React.memo((props) => {
    const filter = useFilterStore(state => state.filters[props.comparableType]?.keywords);
    const setFilters = useFilterStore(state => state.setFilters);

    return (
        <RpKeywordsFilter
            value={filter || []}
            onChange={value => setFilters(props.comparableType, { keywords: value })}
        />
    );
});

KeywordsFilter.propTypes = {
    comparableType: PropTypes.string.isRequired,
};

export default KeywordsFilter;